import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Component({
    selector: 'app-login-layout',
    template: `
    <div class="website-container">
      @if (showNav) {
        <web-navigation></web-navigation>
      }
      <router-outlet></router-outlet>
      @if (showFooter) {
        <web-footer></web-footer>
      }
    </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class WebLayoutComponent {
  showNav: boolean = true;
  showFooter: boolean = true;

  constructor(private router: Router) {
    router.events.forEach((re) => {
      if (re instanceof NavigationStart && re['url'] == '/login') {
        this.showNav = false;
        this.showFooter = false;
      } else {
        this.showNav = true;
        this.showFooter = true;
      }
    });
  }
}
